"use client";
// @refresh reset
// 开发热更新后重建未读 Hook，不能复用修改前的 effect 依赖快照；数据库已读状态不受影响。
import {useEffect,useState} from "react";
import {getMailUnread,mailChangedEvent,sameMailUnread,type MailUnreadSummary} from "@/lib/user/mail-unread";
import {subscribeMailPush} from "@/lib/user/mail-push";

/** 首屏完成后启用服务器邮件推送，摘要轮询作为断线兜底；隐藏页面不轮询但仍可接通知。 */
export function useMailUnread(account:string,enabled:boolean,ready=true){
 const canRefresh=enabled&&ready;
 const[snapshot,setSnapshot]=useState<{account:string;value:MailUnreadSummary}>();
 useEffect(()=>{
  if(!canRefresh||!account)return;
  const controller=new AbortController();let active=true,busy=false,again=false;
  async function refresh(){
   if(document.hidden)return;if(busy){again=true;return;}busy=true;
   try{const value=await getMailUnread(controller.signal);if(active)setSnapshot(current=>current?.account===account&&sameMailUnread(current.value,value)?current:{account,value});}catch{}finally{busy=false;if(again&&active){again=false;void refresh();}}
  }
  const stopPush=subscribeMailPush(controller.signal);
  const update=()=>void refresh();const first=setTimeout(update,0),timer=setInterval(update,30000);
  window.addEventListener(mailChangedEvent,update);window.addEventListener("focus",update);document.addEventListener("visibilitychange",update);
  return()=>{active=false;stopPush();controller.abort();clearTimeout(first);clearInterval(timer);window.removeEventListener(mailChangedEvent,update);window.removeEventListener("focus",update);document.removeEventListener("visibilitychange",update);};
 },[account,canRefresh]);
 return enabled&&snapshot?.account===account?snapshot.value:undefined;
}
